/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InlineResponse20023
 */
export interface InlineResponse20023 {
    /**
     * Payment intent created but still requires action to complete.
     * @type {string}
     * @memberof InlineResponse20023
     */
    nextAction?: string;
}

export function InlineResponse20023FromJSON(json: any): InlineResponse20023 {
    return InlineResponse20023FromJSONTyped(json, false);
}

export function InlineResponse20023FromJSONTyped(json: any, ignoreDiscriminator: boolean): InlineResponse20023 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'nextAction': !exists(json, 'nextAction') ? undefined : json['nextAction'],
    };
}

export function InlineResponse20023ToJSON(value?: InlineResponse20023 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'nextAction': value.nextAction,
    };
}


